import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AbilityService } from 'ability';
import { UiStorageKey, UiStorageType } from 'mbs-ui-shared@models';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UiStorageService {
  private ability = inject(AbilityService);
  private http = inject(HttpClient);

  private apiUrl = 'api/uistorage';
  getSettings(): Observable<UiStorageType> {
    if (this.ability.can('read', 'AgentLocal')) return of({});

    return this.http.get<{ data: [{ key: UiStorageKey; value: any }]; total: number }>(`${this.apiUrl}`).pipe(
      map(({ data }) => {
        return data.reduce((acc, current) => {
          acc[current.key as string] = current.value;

          return acc;
        }, {} as UiStorageType);
      })
    );
  }

  storeSetting(key: UiStorageKey, value: any, addAuditLogRecord = false): Observable<null> {
    return this.http.post<null>(`${this.apiUrl}/${key}${addAuditLogRecord ? '?eventlog=true' : ''}`, value);
  }

  deleteSetting(key: UiStorageKey): Observable<null> {
    return this.http.delete<null>(`${this.apiUrl}/${key}`);
  }
}
